import * as types from '../types'
import { courseCurriculumService } from '../../services/courseCurriculum.service'

/**
 * Fetch course curriculum by course ID
 */
export const fetchCourseCurriculumByCourseId = (courseId) => async (dispatch) => {
    dispatch({ type: types.FETCH_CURRICULUM_REQUEST })

    try {
        const response = await courseCurriculumService.getCourseCurriculumByCourseId(courseId)

        if (response.success && response.data) {
            dispatch({
                type: types.FETCH_CURRICULUM_SUCCESS,
                payload: {
                    courseId: courseId,
                    curriculum: response.data
                }
            })
            return { success: true, data: response.data }
        } else {
            dispatch({
                type: types.FETCH_CURRICULUM_FAILURE,
                payload: response.error || 'Failed to fetch curriculum'
            })
            return { success: false, error: response.error }
        }
    } catch (error) {
        const errorMessage = error.message || 'An error occurred while fetching curriculum'
        dispatch({
            type: types.FETCH_CURRICULUM_FAILURE,
            payload: errorMessage
        })
        return { success: false, error: errorMessage }
    }
}

/**
 * Clear curriculum error
 */
export const clearCourseCurriculumError = () => ({
    type: types.CLEAR_CURRICULUM_ERROR
})
